<template>
  <div>
    <div class="card large">
      <div class="card-image fill">
        <figure class="has-text-centered">
          <img
            :data-src="book.imageUrl"
            :alt="book.name"
            class="book-image lazyload"
          />
        </figure>
      </div>
      <div class="card-content">
        <div class="media">
          <div class="media-left has-text-centered">
            <figure class="image flag">
              <img :src="languageToFlag(book.language)" :alt="book.language" />
            </figure>
            <p class="is-size-7">{{ book.language }}</p>
          </div>
          <div class="media-content">
            <p class="title is-size-6">
              {{ book.name }}
            </p>
            <p class="author subtitle is-size-7">
              {{ book.author }}
            </p>
          </div>
        </div>
        <div class="level is-mobile">
          <div class="level-item has-text-centered">
            <div title="Reader's voice">
              <p class="heading">Voice</p>
              <p class="has-text-weight-bold">{{ book.reader.voice }}</p>
            </div>
          </div>
          <div class="level-item has-text-centered">
            <div title="Total number of paragraphs in the book">
              <p class="heading">Paragraphs</p>
              <p class="has-text-weight-bold">{{ book.sectionCount }}</p>
            </div>
          </div>
          <div class="level-item has-text-centered">
            <div title="Average number of words per paragraph">
              <p class="heading">WPP</p>
              <p class="has-text-weight-bold">
                {{ book.averageWordsPerSection }}
              </p>
            </div>
          </div>
          <div class="level-item has-text-centered">
            <div title="Total duration of the book">
              <p class="heading">Seconds</p>
              <p class="has-text-weight-bold">
                {{ book.totalAudioLengthInSeconds }}
              </p>
            </div>
          </div>
        </div>
        <div class="columns is-centered">
          <div class="column is-11">
            <BookCardSectionBox
              :bookId="book.id"
              :lastSection="lastSectionNumber"
              :lastPracticeMode="lastPracticeMode"
              :loading="loadingOverlay"
            />
          </div>
        </div>
        <div v-if="!this.oidcIsAuthenticated" class="signin has-text-centered">
          <a @click="signIn">
            Sign in to track your progress
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BookCardSectionBox from "@/components/BookCardSectionBox";
import authMixin from "@/mixins/authMixin";

export default {
  name: "BookCard",
  components: { BookCardSectionBox },
  mixins: [authMixin],
  props: {
    book: {
      type: Object,
      required: true
    },
    userOverlay: {
      type: Object,
      required: false
    },
    loadingOverlay: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    bookLink() {
      return `library/${this.book.id}`;
    },
    bookImageStyle() {
      return `background-image: url('${this.book.imageUrl}');`;
    },
    lastSectionNumber() {
      return this.userOverlay?.lastSectionNumber ?? 0;
    },
    lastPracticeMode() {
      return this.userOverlay?.lastPracticeMode;
    }
  },
  methods: {
    languageToFlag(language) {
      switch (language) {
        case "English":
          return require("@/assets/flags/american.png");
        case "French":
          return require("@/assets/flags/french.png");
        case "German":
          return require("@/assets/flags/german.png");
        case "Spanish":
          return require("@/assets/flags/mexican.png");
        case "Portuguese":
          return require("@/assets/flags/brazilian.png");
        default:
          break;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.media-content {
  overflow: visible;
}

.author {
  margin-bottom: 10px;
}

.fill {
  overflow: hidden;
  background-size: cover;
  background-position: center;
}
</style>
